module.exports = __webpack_public_path__ + "static/media/texture-wood-light-brown-v.e12a08cd.jpg";